import { isWebpSupported } from 'react-image-webp/dist/utils'

export const hasWebP = isWebpSupported()

export const isMobile = /iPhone|iPod|Android/i.test(navigator.userAgent)
